/*
* @Author: yongwenhao
* @Date: 2020-04-17 09:23:11
* @describe: 新增/编辑邮箱
*/
<template>
    <KllkDrawer v-model="isShowDrawer" class="create-drawer">
        <!-- 按钮 -->
        <div slot="header" class="header-warp">
            <el-button type="primary" @click="onSave" class="btns">保存</el-button>
            <el-button @click="onCancel" class="btns">取消</el-button>
        </div>
        <el-form
                ref="emailForm"
                label-position="left"
                :model="emailForm"
                :rules="emailRules"
                label-width="90px"
                class="content"
        >
            <el-form-item label="姓名" prop="receiverName">
                <el-input v-model="emailForm.receiverName" maxlength="32"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
                <el-select
                    v-model="emailForm.type"
                    placeholder="请选择语言类型"
                >
                    <el-option label="合作表单" :value="1"></el-option>
                    <el-option label="媒体与投资者" :value="2"></el-option>
                    <el-option label="职位申请" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="emailForm.email" maxlength="128"></el-input>
            </el-form-item>
        </el-form>
    </KllkDrawer>
</template>

<script>
    import KllkDrawer from "../../components/kllk-drawer";
    import {PostAddReceiver, PutEditReceiver} from '../../api/email'

    export default {
        name: "edit-add",
        props: {
            value: Boolean,
            infoFrom: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        components: {KllkDrawer},
        data() {
            return {
                isShowDrawer: this.value,
                emailForm: {
                    receiverName: '',
                    type: 1,
                    email: '',
                },
                emailRules: {
                    receiverName: [{required: true, message: " ", trigger: "blur"}],
                    type: [{required: true, message: " ", trigger: "change"}],
                    email: [{required: true, message: " ", trigger: "blur", type: 'email'}]
                }
            }
        },
        watch: {
            value(n) {
                this.isShowDrawer = n;
            },
            isShowDrawer(n) {
                this.$emit("input", n);
                if (n) {
                    this.emailForm = {...this.infoFrom}
                }
            },
        },
        methods: {
            onSave() {
                this.$refs.emailForm.validate((valid) => {
                    if (valid) {
                        if (this.emailForm.receiverId) {// 修改
                            PutEditReceiver(this.emailForm).then(res => {
                                if (res.status) {
                                    this.$notify.success({
                                        title: '成功',
                                        message: '修改成功',
                                    });
                                    this.$emit("on-update");
                                    this.onCancel();
                                }
                            })
                        } else {// 新增
                            PostAddReceiver({...this.emailForm}).then(res => {
                                if (res.status) {
                                    this.$notify.success({
                                        title: '成功',
                                        message: '新增成功',
                                    });
                                    this.$emit("on-update");
                                    this.onCancel();
                                }
                            })
                        }
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: '请填写正确的信息'
                        });
                        return false;
                    }
                });
            },
            onCancel() {
                this.isShowDrawer = false;
                this.$refs.emailForm.resetFields();
            },
        }
    }
</script>

<style lang='less' scoped>
    .create-drawer {
        .header-warp {
            background: #f5f8fa;
            padding: 16px;

            .btns {
                margin: 0 5px;
            }
        }

        .content {
            padding: 20px;
        }
    }
</style>
